import type { FC, SVGProps } from "react";
import { Bot } from "lucide-react";
import ClaudeIcon from "@/assets/icons/brands/claude.svg?react";
import OpenAiIcon from "@/assets/icons/brands/openai.svg?react";
import GeminiIcon from "@/assets/icons/brands/google_gemini.svg?react";
import KimiIcon from "@/assets/icons/brands/kimi.svg?react";
import MagicStarIcon from "@/assets/icons/magic_star.svg?react";
import { getChatModelProvider } from "@/hooks/useChatModels";
import { cn } from "@/lib/utils";

type IconProps = SVGProps<SVGSVGElement>;

function BrandSvgIcon({
  Icon,
  className,
}: {
  Icon: FC<IconProps>;
  className?: string;
}) {
  return (
    <Icon
      aria-hidden
      className={cn("size-3 [&_path]:fill-current", className)}
    />
  );
}

type Props = {
  modelId: string;
  className?: string;
};

export default function ChatModelProviderIcon({ modelId, className }: Props) {
  if (modelId === "auto") {
    return (
      <BrandSvgIcon
        Icon={MagicStarIcon}
        className={cn("text-co-accent-ink", className)}
      />
    );
  }

  const provider = getChatModelProvider(modelId);

  switch (provider) {
    case "Anthropic":
      return <BrandSvgIcon Icon={ClaudeIcon} className={cn("text-co-text", className)} />;
    case "Google":
      return <BrandSvgIcon Icon={GeminiIcon} className={cn("text-co-text", className)} />;
    case "OpenAI":
      return <BrandSvgIcon Icon={OpenAiIcon} className={cn("text-co-text", className)} />;
    case "Moonshot":
      return <BrandSvgIcon Icon={KimiIcon} className={cn("text-co-text", className)} />;
    default:
      return <Bot aria-hidden className={cn("size-3 text-co-muted", className)} />;
  }
}
